import { Model } from 'pinia-orm';
import { Attr, BelongsTo, Num, Str } from 'pinia-orm/dist/decorators';
import Report from './Report';
import ReportSection from './ReportSection';
/* --- user header --- */
/* --- end user header --- */

export default class ReportSectionConfig extends Model {
  static entity = 'App\\Models\\ReportSectionConfig';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare report_section_id: number;
  @Num(0)
  declare report_id: number;
  @Num(0)
  declare sort_order: number;
  @Attr(undefined)
  declare parameters: unknown[] | undefined;
  // relations
  @BelongsTo(() => ReportSection, 'report_section_id', 'id')
  declare reportSection: ReportSection;
  @BelongsTo(() => Report, 'report_id', 'id')
  declare report: Report;
  /* --- end user code --- */
}
